import React, { useEffect, useState } from 'react';
import axios from 'axios';
import api from '../services/api';

function EtapaConclusao({ onBack, dados, setDados, reiniciar }) {
  const [distancia, setDistancia] = useState(null);
  const [composicao, setComposicao] = useState('');
  const [valorFinal, setValorFinal] = useState(null);
  const [calculando, setCalculando] = useState(true);
  const [enviando, setEnviando] = useState(false);

  const marco =({ logradouro: 'Rua Hervano Macedo Júnior', numero: '105', cidade: 'Juazeiro do Norte', uf: 'CE' })

  const calcularDistancia = async (origem, destino) => {
    try {
      const chave = process.env.REACT_APP_ORS_API_KEY;

      const geocode = async (endereco) => {
        const textoBusca = [endereco?.logradouro || endereco?.endereco, endereco?.numero, endereco?.cidade, endereco?.uf]
          .filter(Boolean)
          .join(', ');

        const resp = await axios.get(`https://api.openrouteservice.org/geocode/search`, {
          params: {
            api_key: chave,
            text: textoBusca,
            boundary_country: 'BR'
          }
        });

        if (!resp.data.features?.length) {
          throw new Error(`Endereço não encontrado: ${textoBusca}`);
        }

        return resp.data.features[0].geometry.coordinates;
      };

      const coordOrigem = await geocode(origem);
      const coordDestino = await geocode(destino);

      const body = {
        locations: [coordOrigem, coordDestino],
        metrics: ['distance'],
        units: 'km'
      };

      const distResp = await axios.post(
        `https://api.openrouteservice.org/v2/matrix/driving-car`,
        body,
        {
          headers: {
            Authorization: chave, // ⚠️ verifique se precisa ser `Authorization: 'Bearer ' + chave`
            'Content-Type': 'application/json'
          }
        }
      );

      const km = distResp.data.distances?.[0]?.[1] ?? null;
      setDistancia(km);
      return km;
    } catch (error) {
      console.error('Erro ao calcular distância:', error);
      setDistancia(null);
      return null;
    }
  };

  const formatarData = (dataIso) => {
    const data = new Date(dataIso);
    return data.toLocaleDateString('pt-BR');
  };

  const calcularEstimativa = (distanciaAtual, distanciaExtra) => {
    const faixasSeguro = [
      { max: 19900, valor: 503.00 },
      { max: 30900, valor: 536.90 },
      { max: 55900, valor: 551.61 },
      { max: 60900, valor: 589.73 },
      { max: 80900, valor: 620.39 },
      { max: 100000, valor: 654.11 },
      { max: 120900, valor: 805.39 },
      { max: 139900, valor: 868.39 },
      { max: 170000, valor: 958.10 },
      { max: 180000, valor: 1014.00 },
      { max: 190000, valor: 1070.00 },
      { max: 200000, valor: 1300.78 },
      { max: 300000, valor: 1951.17 },
      { max: 400000, valor: 2459.00 },
      { max: 500000, valor: 3074.00 },
    ];

    const calcularSeguro = (valorTotal) => {
      for (let faixa of faixasSeguro) {
        if (valorTotal <= faixa.max) return faixa.valor;
      }
      return 0;
    };

    const itens = dados.etapa5?.itens || [];
    const totalVolume = itens.reduce((acc, item) => acc + parseFloat(item.totalM3 || 0), 0);
    const tipoServico = dados.etapa3?.tipoServico?.tipo?.toLowerCase() || '';
    const subTipo = dados.etapa3?.tipoServico?.subtipo;
    const origem = dados.etapa4?.origem || {};
    const destino = dados.etapa4?.destino || {};
    const exclusividade = dados.etapa4?.exclusividade;
    const seguro = dados.etapa4?.seguro;
    const valorTotal = dados.etapa5?.valorTotal || 0;
    const andarOrigem = origem?.andar || 0;
    const andarDestino = destino?.andar || 0;

    const cidadesLocais = ['juazeiro do norte', 'crato', 'barbalha'];
    const cidadeOrigem = origem.cidade?.toLowerCase();
    const cidadeDestino = destino.cidade?.toLowerCase();
    const ufOrigem = origem.uf?.toUpperCase();
    const ufDestino = destino.uf?.toUpperCase();

    const km = distanciaAtual || 100;
    const km2 = distanciaExtra || 0;
    const caminhao = totalVolume > 30 ? 'grande' : 'pequeno';

    let vServico = 0;
    const vEmpacotamento = 34;
    const vMontagem = totalVolume > 30 ? 36 : 18;
    let descricao = '';

    const adicionalAndar = (andarOrigem >= 3 ? andarOrigem * 20 : 0) + (andarDestino >= 3 ? andarDestino * 20 : 0);
    const valorSeguro = seguro ? calcularSeguro(valorTotal) : 0;
    const descricaoSeguro = seguro ? `\n- Seguro: R$ ${valorSeguro.toFixed(2)}` : '';

    if (tipoServico === 'mudanca') {
      if (subTipo === 'Completa') {
        if (ufOrigem?.toUpperCase() === 'CE' && ufDestino?.toUpperCase() === 'CE') {
          const locais = cidadesLocais.includes(cidadeOrigem) && cidadesLocais.includes(cidadeDestino);
          vServico = locais ? (caminhao === 'pequeno' ? 300 : 600) : (caminhao === 'pequeno' ? (km + km2) * 3.6 : (km + km2) * 6);
        } else {
          vServico = caminhao === 'pequeno' ? (km + km2) * 3.6 : (km + km2) * 6;
        }

        if (exclusividade) vServico *= 2;

        const totalEmpacotamento = totalVolume * vEmpacotamento;
        const totalMontagem = totalVolume * vMontagem;
        const total = vServico + totalEmpacotamento + totalMontagem + adicionalAndar + valorSeguro;

        descricao = `Cálculo Detalhado:\n- Adicional Andar: R$ ${adicionalAndar}`+
                    `${descricaoSeguro}`+
                    `\n- Empacotamento (${totalVolume} m³ x R$${vEmpacotamento}): R$ ${totalEmpacotamento.toFixed(2)}`+
                    `\n- Montagem (${totalVolume} m³ x R$${vMontagem}): R$ ${totalMontagem.toFixed(2)}`+                    
                    `\n- Distância estimada: ${(km).toFixed(1)} km (Origem e Destino) + ${(km2).toFixed(1)} km (Ponto de partida) = ${(km + km2).toFixed(1)} km`+
                    `\n- Serviço: R$ ${vServico.toFixed(2)}`+
                    `\n- Total estimado: R$ ${total.toFixed(2)}`;
        setComposicao(descricao);
        return total;
      }

      if (subTipo === 'Tradicional') {
        if (ufOrigem?.toUpperCase() === 'CE' && ufDestino?.toUpperCase() === 'CE') {
          const locais = cidadesLocais.includes(cidadeOrigem) && cidadesLocais.includes(cidadeDestino);
          vServico = locais ? (caminhao === 'pequeno' ? 300 : 600) : (caminhao === 'pequeno' ? (km + km2) * 3.6 : (km + km2) * 6);
        } else {
          vServico = caminhao === 'pequeno' ? (km + km2) * 3.6 : (km + km2) * 6;
        }

        if (exclusividade) vServico *= 2;

        const totalEmpacotamento = totalVolume * vEmpacotamento;
        const total = vServico + totalEmpacotamento + adicionalAndar + valorSeguro;

        descricao = `Cálculo Detalhado:\n- Adicional Andar: R$ ${adicionalAndar}`+
        `${descricaoSeguro}`+       
        `\n- Empacotamento (${totalVolume} m³ x R$${vEmpacotamento}): R$ ${totalEmpacotamento.toFixed(2)}`+       
        `\n- Distância estimada: ${(km).toFixed(1)} km (Origem e Destino) + ${(km2).toFixed(1)} km (Ponto de partida) = ${(km + km2).toFixed(1)} km`+
        `\n- Serviço: R$ ${vServico.toFixed(2)}`+
        `\n- Total estimado: R$ ${total.toFixed(2)}`;
        setComposicao(descricao);
        return total;
      }

      if (subTipo === 'Econômica') {
        if (ufOrigem?.toUpperCase() === 'CE' && ufDestino?.toUpperCase() === 'CE') {
          const locais = cidadesLocais.includes(cidadeOrigem) && cidadesLocais.includes(cidadeDestino);
          vServico = locais ? (caminhao === 'pequeno' ? 300 : 600) : (caminhao === 'pequeno' ? (km + km2) * 3.6 : (km + km2) * 6);
        } else {
          vServico = caminhao === 'pequeno' ? (km + km2) * 3.6 : (km + km2) * 6;
        }

        if (exclusividade) vServico *= 2;

        const total = vServico + adicionalAndar + valorSeguro;

        descricao = `Cálculo Detalhado:\n- Adicional Andar: R$ ${adicionalAndar}`+
        `${descricaoSeguro}`+              
        `\n- Distância estimada: ${(km).toFixed(1)} km (Origem e Destino) + ${(km2).toFixed(1)} km (Ponto de partida) = ${(km + km2).toFixed(1)} km`+
        `\n- Serviço: R$ ${vServico.toFixed(2)}`+ 
        `\n- Total estimado: R$ ${total.toFixed(2)}`;
        setComposicao(descricao);
        return total;
      }
    }

    if (tipoServico === 'frete') {
      const total = 150 + adicionalAndar + valorSeguro;
      descricao = `Cálculo Detalhado:\n- Frete: R$ 150.00`+
      `\n- Adicional Andar: R$ ${adicionalAndar}`+
      `${descricaoSeguro}`+              
      `\n- Distância estimada: ${(km).toFixed(1)} km (Origem e Destino) + ${(km2).toFixed(1)} km (Ponto de partida) = ${(km + km2).toFixed(1)} km`+
      `\n- Total estimado: R$ ${total.toFixed(2)}`;
      setComposicao(descricao);
      return total;
    }

    if (tipoServico === 'mercadoria') {
      const totalMercadoria = 250 + totalVolume * 100;
      const total = totalMercadoria + adicionalAndar + valorSeguro;
      descricao = `Cálculo Detalhado:\n- Mercadoria: R$ ${totalMercadoria.toFixed(2)}`+
      `\n- Adicional Andar: R$ ${adicionalAndar}`+
      `${descricaoSeguro}`+             
      `\n- Distância estimada: ${(km).toFixed(1)} km (Origem e Destino) + ${(km2).toFixed(1)} km (Ponto de partida) = ${(km + km2).toFixed(1)} km`+
      `\n- Total estimado: R$ ${total.toFixed(2)}`;
      setComposicao(descricao);
      return total;
    }

    if (tipoServico === 'veiculo') {
      if (subTipo === 'Moto') {
        vServico = (ufOrigem.toUpperCase() === 'CE' && ufDestino.toUpperCase() === 'CE') ? 300 : 800;
      } else if (subTipo === 'Carro') {
        vServico = (ufOrigem.toUpperCase() === 'CE' && ufDestino.toUpperCase() === 'CE') ? 800 : 1200;
      }

      const total = vServico + adicionalAndar + valorSeguro;
      descricao = `Cálculo Detalhado:\n- Transporte de Veículo: R$ ${vServico.toFixed(2)}`+
      `\n- Adicional Andar: R$ ${adicionalAndar}`+
      `${descricaoSeguro}`+             
      `\n- Distância estimada: ${(km).toFixed(1)} km (Origem e Destino) + ${(km2).toFixed(1)} km (Ponto de partida) = ${(km + km2).toFixed(1)} km`+
      `\n- Total estimado: R$ ${total.toFixed(2)}`;
      setComposicao(descricao);
      return total;
    }

    return 0;
  };

  useEffect(() => {
    const executar = async () => {
      setCalculando(true);
      const km = await calcularDistancia(dados.etapa4?.origem, dados.etapa4?.destino);
      const km2 = dados.etapa4?.exclusividade ? await calcularDistancia(marco, dados.etapa4?.origem) : 0;  
      const valor = calcularEstimativa(km, km2);
      setValorFinal(valor);
      setCalculando(false);
    };
    executar();
  }, [dados.etapa4]);

  const enviarOrcamento = async () => {
    try {
      setEnviando(true);
      const cliente = dados.etapa1?.cliente;
      const mensagem = `Olá ${cliente?.nome}, aqui está o resumo do seu orçamento:\n\n` +
        `Serviço: ${dados.etapa3?.tipoServico?.titulo}\n` +
        `Descrição: ${dados.etapa3?.tipoServico?.descricao}\n` +
        `Detalhes: ${dados.etapa3?.detalhes?.tipo?.subtipo || 'Não informado'}\n\n` +
        `Origem: ${dados.etapa4?.origem?.cep} - ${dados.etapa4?.origem?.logradouro}, ${dados.etapa4?.origem?.numero} - ${dados.etapa4?.origem?.bairro} - ${dados.etapa4?.origem?.cidade}/${dados.etapa4?.origem?.uf}\n` +
        `Destino: ${dados.etapa4?.destino?.cep} - ${dados.etapa4?.destino?.logradouro}, ${dados.etapa4?.destino?.numero} - ${dados.etapa4?.destino?.bairro} - ${dados.etapa4?.destino?.cidade}/${dados.etapa4?.destino?.uf}\n\n` +        
        `Data do serviço: ${formatarData(dados.etapa4?.dataServico)}\n\n` +
        `Composição:\n ${composicao}`+
        `Valor estimado: R$ ${valorFinal.toFixed(2).replace('.', ',')}\n\n` +
        `Agradecemos o seu contato.`;

      const numeroCliente = cliente?.whatsapp?.replace(/\D/g, '');
      const numeroEmpresa = '88999593948';

      if (numeroCliente) {
        window.open(`https://wa.me/55${numeroCliente}?text=${encodeURIComponent(mensagem)}`, '_blank');
      }
      window.open(`https://wa.me/55${numeroEmpresa}?text=${encodeURIComponent(mensagem)}`, '_blank');

      const dadosCompletos = {
        ...dados,
        etapa7: {
          valorProposto: valorFinal
        }
      };

      console.log("dados completos"+ dadosCompletos);

      await api.post('operacao/v2/orcamento2', dadosCompletos);
      alert('Orçamento enviado com sucesso!');
      setDados({});
      reiniciar(0);

    } catch (error) {
      alert('Erro ao enviar orçamento.');
      console.error(error);
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div>
      <h4 className="fw-semibold text-center mb-4" style={{ fontSize: '1.5rem', color: '#444' }}>Resumo do Orçamento</h4>

      <div className="border rounded p-3 bg-light mb-4">
        <h5>Cliente</h5>
        <p><strong>Nome:</strong> {dados.etapa1?.cliente?.nome}</p>
        <p><strong>CPF/CNPJ:</strong> {dados.etapa1?.cliente?.cpfCnpj}</p>
        <p><strong>Contato:</strong> {dados.etapa1?.cliente?.telefone} / {dados.etapa1?.cliente?.whatsapp}</p>
      </div>

      <div className="border rounded p-3 bg-light mb-4">
        <h5>Serviço Selecionado</h5>
        <p><strong>Tipo:</strong> {dados.etapa3?.tipoServico?.titulo}</p>
        <p><strong>Descrição:</strong> {dados.etapa3?.tipoServico?.descricao}</p>
        <p><strong>Detalhes:</strong> {dados.subtipoSelecionado || 'Não informado'}</p>
      </div>

      <div className="border rounded p-3 bg-light mb-4">
        <h5>Itens</h5>
        <ul>
          {(dados.etapa5?.itens || []).map((item, i) => (
            <li key={i}>
              <strong>{item.descricao || 'Sem descrição'}</strong> – Qtd: <strong>{item.quantidade}</strong>, M³: <strong>{item.totalM3}</strong>
            </li>
          ))}
        </ul>
      </div>

      <div className="border rounded p-3 bg-light mb-4">
        <h5>Detalhes Adicionais</h5>
        <p><strong>Data do Serviço:</strong> {formatarData(dados.etapa4?.dataServico)}</p>
        <p><strong>Exclusividade:</strong> {dados.etapa4?.exclusividade ? 'Sim' : 'Não'}</p>
        <p><strong>Armazenar Itens:</strong> {dados.etapa4?.armazenar ? 'Sim' : 'Não'}</p>
        <p><strong>Origem:</strong> {dados.etapa4?.origem?.logradouro}, {dados.etapa4?.origem?.numero}, {dados.etapa4?.origem?.cidade}/{dados.etapa4?.origem?.uf}</p>
        <p><strong>Destino:</strong> {dados.etapa4?.destino?.logradouro}, {dados.etapa4?.destino?.numero}, {dados.etapa4?.destino?.cidade}/{dados.etapa4?.destino?.uf}</p>
        <p><strong>Observações:</strong> {dados.etapa4?.observacao || 'Nenhuma'}</p>
      </div>

      <div className="border rounded p-3 bg-light mb-4">
        <h5>Termo</h5>
        <p>
          {dados.etapa6?.termoAceito
            ? 'O cliente aceitou os termos de transporte.'
            : 'Termo não aceito (erro na validação).'}
        </p>
      </div>

      <div className="alert alert-success">
        <h5>Estimativa de Valor</h5>
        {calculando ? (
          <>
            <div className="spinner-border spinner-border-sm text-success" role="status" style={{ marginRight: 8 }}></div>
            <span>Calculando estimativa, por favor aguarde...</span>
          </>
        ) : (
          <>
            <pre>{composicao}</pre>
            <p>
              Valor estimado: <strong>R$ {valorFinal !== null ? valorFinal.toFixed(2).replace('.', ',') : 'Indisponível'}</strong>
            </p>
            <small>Este valor é uma estimativa e pode variar após avaliação detalhada.</small>
          </>
        )}
      </div>

      <div className="d-flex justify-content-between mt-4">
        <button className="btn btn-secondary" onClick={onBack}>Voltar</button>
        <button className="btn btn-success" onClick={enviarOrcamento} disabled={calculando || enviando}>
          {enviando ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Enviando...
            </>
          ) : (
            'Finalizar e Enviar'
          )}
        </button>
      </div>
    </div>
  );
}

export default EtapaConclusao;
